var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量改库存",
        visible: _vm.dialogVisible,
        width: "92%",
        top: "4vh",
        "append-to-body": "",
        "close-on-click-modal": false,
        "custom-class": "batch-inventory-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _vm.visible
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.submitting,
                  expression: "submitting",
                },
              ],
              key: _vm.contentKey,
              staticClass: "batch-inventory-body",
            },
            [
              _c("div", { staticClass: "batch-inventory-layout" }, [
                _c(
                  "div",
                  { staticClass: "batch-inventory-tabs" },
                  _vm._l(_vm.products, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "batch-tab-item",
                        class: {
                          active: String(item.id) === _vm.activeProductId,
                        },
                        attrs: { title: item.productName },
                        on: {
                          click: function ($event) {
                            _vm.activeProductId = String(item.id)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "batch-tab-label" }, [
                          _vm._v(_vm._s(item.productName)),
                        ]),
                        _vm._v(" "),
                        _vm.getTabStatus(item.id) === "error"
                          ? _c("i", {
                              staticClass: "el-icon-warning warning-icon",
                            })
                          : _vm.getTabStatus(item.id) === "done"
                          ? _c("i", {
                              staticClass: "el-icon-circle-check success-icon",
                            })
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "batch-inventory-content" },
                  _vm._l(_vm.products, function (item) {
                    return _c("inventory-adjust", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: String(item.id) === _vm.activeProductId,
                          expression: "String(item.id) === activeProductId",
                        },
                      ],
                      key: _vm.contentKey + "_" + item.id,
                      ref: "adjust_" + item.id,
                      refInFor: true,
                      attrs: {
                        "product-id": item.id,
                        "biz-type": _vm.bizType,
                        embedded: "",
                      },
                    })
                  }),
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "batch-remark-form",
                  attrs: { "label-width": "100px", size: "small" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "调整原因", required: "" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          placeholder:
                            "请输入本次批量库存调整原因（所有商品共用）",
                        },
                        model: {
                          value: _vm.adjustRemark,
                          callback: function ($$v) {
                            _vm.adjustRemark = $$v
                          },
                          expression: "adjustRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.submitting,
              },
              on: { click: _vm.submitBatch },
            },
            [_vm._v("提交调整")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }